import {cx} from '@local/utils/cx'
import React, {ReactNode} from 'react'

interface ContainerProps {
	clip?: boolean
	bleed? : boolean
	children?: ReactNode
	className?: string
}

/**
 * Helper component with a responsive container that has a maxWidth
 */
export const Container: React.FC<ContainerProps> = ({
	clip,
	bleed = false,
	className,
	children,
}) => {
	return (
		<div
			className={cx(
				!bleed ? 'grid-container' : 'w-full',
				clip && 'overflow-clip',
				className,
			)}>
			{children}
		</div>
	)
}
